const COMMENT_REACTIONS_FETCH_EVENT = 'COMMENT_REACTIONS_FETCH_EVENT';
const ARTICLE_REACTIONS_FETCH_EVENT = 'ARTICLE_REACTIONS_FETCH_EVENT';

const dispatchCommentReactionsFetchEvent = () => {
  document.dispatchEvent(new CustomEvent(COMMENT_REACTIONS_FETCH_EVENT));
};

const dispatchArticleReactionsFetchEvent = () => {
  document.dispatchEvent(new CustomEvent(ARTICLE_REACTIONS_FETCH_EVENT));
};

export {
  dispatchCommentReactionsFetchEvent,
  dispatchArticleReactionsFetchEvent,
  COMMENT_REACTIONS_FETCH_EVENT,
  ARTICLE_REACTIONS_FETCH_EVENT
};
